var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layoutName,{tag:"component",attrs:{"material":_vm.materials[0],"has-event-tag":_vm.hasEventTag,"has-tail-btn":_vm.hasTailBtn},on:{"ads:click":_vm.onAdsClick,"ads:entry":_vm.onAdsEntry}})}
var staticRenderFns = []

export { render, staticRenderFns }